'use es6';

import { CUSTOMER_CURRENCY_CODE_RECEIVED } from 'pricing-pages-unified-ui/constants/ActionTypes';
const initialState = null;

const CustomerCurrencyCode = (state = initialState, {
  type,
  payload,
  isPublic
}) => {
  switch (type) {
    case CUSTOMER_CURRENCY_CODE_RECEIVED:
      return isPublic ? null : payload;

    default:
      return state;
  }
};

export default CustomerCurrencyCode;